import React, {useEffect, useState} from 'react'
import _ from "lodash";
import SelectTags from "../tag/select-tags";
import SelectThemes from "../theme/components/select-themes";

const EditImageDetail = ({imageDetail, allThemes, allTags, handleSelectImageChanges}) => {
    
    const handleSelectTagsChanges = (event) => {
        handleSelectImageChanges(event);
    }

    return (
        <>
            <div className="flex justify-start w-full">
                <div className="field-group-container">

                    <div className="field-container">
                        <div className="field-label">
                            Display Label
                        </div>
                        <input
                            type="text"
                            className="input-field-max"
                            id="displayLabel"
                            name="displayLabel"
                            value={imageDetail?.displayLabel || ''}
                            onChange={handleSelectImageChanges}>
                        </input>
                    </div>

                    {imageDetail?.width &&
                        <div className="field-container">
                            <div className="field-label">
                                Width
                            </div>
                            <input
                                type="number"
                                className="input-field"
                                id="width"
                                name="width"
                                disabled
                                value={imageDetail?.width}
                                onChange={handleSelectImageChanges}>
                            </input>
                        </div>
                    }


                    {imageDetail?.height &&
                        <div className="field-container">
                            <div className="field-label">
                                Height
                            </div>
                            <input
                                type="number"
                                className="input-field"
                                id="height"
                                name="height"
                                disabled
                                value={imageDetail?.height}
                                onChange={handleSelectImageChanges}>
                            </input>
                        </div>
                    }

                </div>
            </div>

            <div
                className="h-44 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mx-2 mt-2 shadow-xl">
                {allTags &&
                    <SelectTags
                        existingTags={imageDetail?.tagList}
                        allTags={allTags}
                        handleSelectTagsChanges={handleSelectTagsChanges}
                        showAddTag="true"
                        showClearSelectedTags={false}
                        showClearSelectedTagsIcon={false}/>
                }
            </div>

            <div>
                {allThemes && allThemes?.length > 0 &&
                    <div
                        className="h-40 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mx-2 mt-2">
                        <SelectThemes
                            existingThemes={imageDetail?.themeList}
                            allThemes={allThemes}
                            handleSelectThemesChanges={handleSelectTagsChanges}
                            showClearSelectedThemes={false}
                            showClearSelectedThemesIcon={false}/>
                    </div>
                }
            </div>

        </>
    )
}

export default EditImageDetail
